<template>
  <div class="assignment-box__container">
    <GenericCard>
      <div class="assignment-box__card">
        <AssignBoxForm
          title-form="Asignar Box"
          :headquarters="headquartersList"
          :boxes="boxList"
          :priority-types="priorityList"
          :attention-queues="queueList"
          :loading="loading"
          :formFieldsDefault="formValue"
          @submit="assignBox"
        />
      </div>
    </GenericCard>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GenericCard from '@/infrastructure/vue/components/common/cards/GenericCard';
import AssignBoxForm from '@/infrastructure/vue/components/common/forms/AssignBoxForm';
export default {
  name: 'AssignmentBox',
  components: {
    GenericCard,
    AssignBoxForm,
  },
  data: () => ({
    loading: false,
    defaultForm: null,
  }),
  computed: {
    ...mapGetters('box', [
      'headquartersList',
      'priorityList',
      'queueList',
      'boxList',
    ]),
    ...mapGetters('login', ['user']),
    ...mapGetters('box', ['assignmentDetail']),
    formValue() {
      return this.defaultForm;
    },
  },
  methods: {
    async assignBox(payload) {
      this.loading = true;
      await this.$store.dispatch('box/saveAssignmentAction', {
        ...payload,
        userCode: this.user.userCode,
        attentionType: this.user.attentionType,
      });
      this.loading = false;
    },
    handleValidaNullArray(array) {
      if (array) {
        return array.filter(function (elemento) {
          return elemento !== null;
        });
      } else {
        return null;
      }
    },
    handleDefaultDatatoForm() {
      this.defaultForm = {
        headquarter: this.user.headquartersCode,
        box: this.assignmentDetail?.boxCode,
        priority: this.handleValidaNullArray(
          this.assignmentDetail?.arrayAttentionType
        ),
        attentionQueue: this.handleValidaNullArray(
          this.assignmentDetail?.arrayAttentionQueue
        ),
      };
    },
  },

  async created() {
    await this.$store.dispatch('box/headquartersListAction');
    await this.$store.dispatch('box/boxListAction', {
      attentionType: this.user.attentionType,
      headquartersCode: this.user.headquartersCode,
      userCode: this.user.userCode,
    });
    await this.$store.dispatch('box/priorityListAction');
    await this.$store.dispatch('box/queueListAction');
    this.handleDefaultDatatoForm();
  },
};
</script>

<style lang="scss" scoped>
.assignment-box {
  &__container {
    width: 480px;
    margin: 0 auto;
  }
  &__card {
    padding: 40px;
  }
}
</style>
